import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const ConfirmDialogContext = createContext(null);

export function useConfirm() {
  const context = useContext(ConfirmDialogContext);
  if (!context)
    throw new Error("useConfirm must be used within ConfirmDialogProvider");
  return context;
}

export function ConfirmDialogProvider({ children }) {
  const [dialogState, setDialogState] = useState({ open: false });
  const [resolver, setResolver] = useState(null);

  const confirm = ({
    message,
    title = "Confirmação",
    confirmText = "Confirmar",
    cancelText = "Cancelar",
  }) => {
    return new Promise((resolve) => {
      setDialogState({ open: true, message, title, confirmText, cancelText });
      setResolver(() => resolve);
    });
  };

  const handleClose = (result) => {
    setDialogState({ open: false });
    if (resolver) resolver(result);
  };

  return (
    <ConfirmDialogContext.Provider value={confirm}>
      {children}
      <Dialog
        slotProps={{
          paper: {
            sx: { minWidth: "25rem", minHeight: "10rem", padding: "0.5rem" },
          },
        }}
        open={dialogState.open}
        onClose={() => handleClose(false)}
      >
        <DialogTitle>{dialogState.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogState.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>
            {dialogState.cancelText}
          </Button>
          <Button onClick={() => handleClose(true)} autoFocus>
            {dialogState.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmDialogContext.Provider>
  );
}
